






























































































import { Component, Vue } from "vue-property-decorator";
import {
  RimRepairLayoutComponent,
  RimRepairLoadingComponent
} from "@/components/common";
import { IUserResponseData, IUser, Callback } from "@/interfaces";
import { SearchUsers, ChangeUserStatus } from "@/api";
import { DataTableHeader } from "vuetify";
import { Getter, Action } from "vuex-class";
import { HELPER } from "@/utils/Helper";
import { Watch, Prop } from "vue-property-decorator";
import { UserInterface } from "@/utils/UserInterface";

@Component({
  components: {
    RimRepairLayoutComponent,
    RimRepairLoadingComponent
  }
})
export default class UsersComponent extends Vue {
  @Action("setSnackbar", { namespace: "AppModule" })
  public setSnackbarAction!: Callback;

  public search = "";
  public page = 0;
  public size = 5;
  public total = 0;
  public users: IUser[] = [];
  public debounce!: number;
  public headers: DataTableHeader[] = [
    {
      text: "Initials",
      value: "Initials"
    },
    {
      text: "Full name",
      value: "fullName"
    },
    {
      text: "Email",
      value: "Email"
    },
    { text: "Roles", value: "roles", sortable: false },
    { text: "", value: "edit", sortable: false },
    { text: "Active", value: "status", sortable: false }
  ];
  public loading = false;
  public addUserRoute = "/users/add";
	public Status: any[] = [];
	public employeeStatus: boolean = true;

	private UI__: UserInterface;

  @Getter("getTimestampUsers", { namespace: "AppModule" })
  private getTimestampUsers: string;

  @Watch("getTimestampUsers")
  onValueChanged(newVal: any, oldVal: any) {
		/// WE ARE WATCHING A VUEX VARIABLE THAT TELLS 
		/// IF THE USERS CHANGED, IN WHICH CASE WE SHOULD
		/// TRIGGER A NEW SEARCH.
		this.searchUsers();
	}





	mounted() {
	    this.UI__ = new UserInterface(this);

			this.Status.push({ N: 'Active', V: true });
			this.Status.push({ N: 'Inactive', V: false });
			this.Status.push({ N: 'Any', V: null });

		this.RestoreSearch();
    this.searchUsers();
	}


	private PreserveSearch():void{
		HELPER.Preserve("users-search",  {
			search: this.search,
			employeeStatus: this.employeeStatus,
			size: this.size,
		})
	}

	private RestoreSearch():void{
		var o = HELPER.Restore("users-search");
		if (o==null)return;
		this.search = o.search;
		this.employeeStatus = o.employeeStatus;
		this.size = o.size;
	}


  async searchUsers() {

		this.PreserveSearch();
  
    try {
			this.UI__.TurnBlockerOn();
      this.loading = true;
      const page = this.page - 1 > 0 ? this.page - 1 : 0;
      const resp = await SearchUsers(this.search, this.employeeStatus,  
															page, this.size);
      if (resp.Ok) {
        this.users = resp.Results.Users;
        this.setPagination(resp.Results);
      }
			this.UI__.TurnBlockerOff();
      this.loading = false;
    } catch (err) {
      //
    }
  }

  setPagination(data: IUserResponseData) {
    this.page = data.Page! + 1;
    // this.size = data.PageSize!;
    this.total = data.TotalRecords;
  }

  changePagination(page: number) {
    this.page = page;
    this.searchUsers();
  }

  get pages() {
		var rval:number =0;
		if (!this.size){
			rval = 1;
		}else{
    rval= Math.ceil(this.total / this.size);
		}
		return rval;
	}

  searchFn() {
    clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      this.page = 0;
      // this.size = 5;
      this.searchUsers();
    }, 500);
  }

  goTo(path: string): void {
    if (this.$route.path !== path) this.$router.push(path);
  }

  editUser(user: IUser): void {
    this.$router.push({
      path: `/users/edit/${user.RecordID}`
    });
  }

  async setStatus(user: IUser) {
    try {
			this.UI__.TurnBlockerOn();
      // this.statusLoading = true;
      const resp = await ChangeUserStatus(user.RecordID!, user.IsActive);
      // this.statusLoading = false;
			this.UI__.TurnBlockerOff();

      if (resp.Ok) {
        // this.searchUsers();
				this.UI__.SnacSuccess("User Status changed successfully");
        // this.setSnackbarAction({
        //   message: "User Status changed successfully",
        //   status: "success"
        // });

				this.UI__.IntakeStaffStatusChange(resp.User);
      }
    } catch (err) {
      //
    }
  }
}


